import { servicePost } from "./client.ts";

/**
 * Shared link data format.
 *
 * `page` identifies the route page to navigate to.
 * `state` is the page state blob in the same format as sessionStorage/URL hash storage:
 *   - `f.{gridName}` = compact filter array (per grid, supports multi-grid pages)
 *   - `edit` = edit selection ID
 *   - Other reserved sub-keys for future use
 *
 * Example:
 * ```json
 * {
 *   "page": "transactionSearch",
 *   "state": {
 *     "f.transactionSearch": [{"c":"iKioskID","v":"19","t":6}],
 *     "edit": "42"
 *   }
 * }
 * ```
 */
export interface SharedLinkData {
  page: string;
  state: Record<string, unknown>;
}

export interface SharedLinkResult {
  EndpointID: number;
  Data: string; // JSON-encoded SharedLinkData
}

export function createSharedLink(endpointID: number, jsonData: string) {
  return servicePost<string>("WebCreateSharedLink", { endpointID, jsonData });
}

export function getSharedLink(id: string) {
  return servicePost<SharedLinkResult>("WebGetSharedLink", { id });
}
